import { jsPDF } from 'jspdf';

export const downloadPdf = async (fileName = 'export.pdf', element) => {
	if (!element) return;

	const MARGIN = 5;

	const doc = new jsPDF({
		unit: 'mm',
		format: 'a4',
	});

	return new Promise((resolve) => {
		doc.html(element, {
			callback: function (doc) {
				doc.save(`${fileName}.pdf`);
				resolve(); // resolve when finished
			},
			margin: MARGIN,
			x: MARGIN,
			y: MARGIN,
			html2canvas: { scale: 0.2 },
			autoPaging: 'text',
		});
	});
};
